import React from 'react'
import Profilepic from '../img/mypro.png'
import { TypeAnimation } from 'react-type-animation'
import BackgroundImage from '../img/background1.png';


const Hero = () => {
  return (
    <>
    <div className='grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-[100%] h-[110vh] lg:h-[85vh] mx-auto py-8 '
    style={{
      backgroundImage: `url(${BackgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }}>
      

<div className='ms-16 col-span-1 my-auto mx-auto lg:w-[500px] h-auto lg:w-[600px] sm:w-[400px] h-auto sm:w-[500px]'>
  <img className='sm:align-middle' src={Profilepic} alt="pro pic"/>
</div>
<div className='col-span-2 px-5 my-auto mt-[-30px] lg:mt-[110px]'>
<h1 className='ms-10 text-white text-3xl sm:text-4xl lg:text-5xl font-extrabold'>
<span className='primary-color'>
  I ' am a
</span><br/>
<TypeAnimation
sequence={[
  "Web Developer",
  1000,
  "Frontend Developer",
  1000,
  "Backend Developer",
  1000,
  "Database Designer",
  1000,
]}
wrapper='span'
speed={50}
repeat={Infinity}
/>
</h1>
<p className='text-white sm:text-lg my-6 lg:text-xl ms-10'>
  My Name is Hansi Dileesha and I am undergraduated in Software Engineering
</p>
<div className='my-8'>
  <a href='/Hansi_Dileesha_MyCV.pdf'
  download="Hansi_Dileesha_MyCV.pdf"
  className='ms-10 px-6 py-3 w-full rounded-xl mr-4 
  bg-gradient-to-br from-blue-500 to-pink-500 text-white'>
    Download My CV
  </a>
  {/* <a href="#contact" className='px-6 py-3 w-full rounded-xl mr-4 border border-gray-400 hover:bg-gradient-to-br from-blue-500 to-pink-500 text-white hover:border-none'>
  Contact Me
  </a> */}
</div>

</div>
</div>
<div id='skill'></div>
 </>
  )
}

export default Hero
